import groundcover from '@groundcover/browser'
import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import defu from 'defu'

export type GroundcoverParams = NonNullable<
  Parameters<typeof groundcover.init>[0]
>

export default defineNuxtPlugin({
  name: 'nuxt-groundcover',
  setup(nuxtApp) {
    const { config } = useRuntimeConfig().public.groundcover ?? {}

    // ponytail: dsn/cluster hardcoded until multiple backends/regions exist
    const groundcoverParams = defu(config, {
      dsn: 'https://tevicq4nl.platform.grcv.io',
      cluster: 'workflows-apps',
      options: {
        privacy: {
          level: 'mask-sensitive',
          // TODO(WFL-7311): We may want to change this selector
          maskSelectors: ['[data-dd-privacy="mask"]'],
        },
      },
    }) as GroundcoverParams

    groundcover.init(groundcoverParams)

    groundcover.startReplayRecording()

    // vue's default warn logs raw vnodes that the SDK serializes whole; groundcoverIgnore drops the event
    nuxtApp.vueApp.config.warnHandler = (msg, _instance, trace) =>
      console.warn(`[Vue warn]: ${msg}\n${trace}`, { groundcoverIgnore: true })

    return {
      provide: {
        groundcover,
      },
    }
  },
})
